import { MenuItem, Theme, Typography } from "@mui/material";
interface LanguageMenuItemProps {
  value: string;
  changeLanguage: (language: string) => void;
  language: string;
}
interface ITextMapping {
  [key: string]: string;
}
const textMapping: ITextMapping = {
  fi: "Suomi",
  default: "English",
};

export const LanguageMenuItem: React.FC<LanguageMenuItemProps> = ({
  value,
  changeLanguage,
  language,
}) => {
  const text = textMapping[value] || textMapping.default;
  const isSelectedLanguage = language === value;

  const languageSX = (theme: Theme) => ({
    display: "flex",
    justifyContent: "center",
    padding: "16px 24px",
    backgroundColor: isSelectedLanguage
      ? theme.palette.primary.dark
      : theme.palette.primary.light,
    color: isSelectedLanguage
      ? theme.palette.common.white
      : theme.palette.secondary.main,
    borderBottom: `1px solid ${theme.palette.common.white}`,
    "&:hover": {
      backgroundColor: isSelectedLanguage
        ? theme.palette.primary.dark
        : theme.palette.primary.light,
      color: isSelectedLanguage
        ? theme.palette.common.white
        : theme.palette.secondary.dark,
    },
  });

  return (
    <>
      <MenuItem
        key={value}
        onClick={function () {
          changeLanguage(value);
        }}
        disableRipple
        sx={languageSX}>
        <Typography variant="body2">{text}</Typography>
      </MenuItem>
    </>
  );
};
